import React, { useState } from 'react'
import { Buttons, CustomAlertDialog, GenericContainer } from '../../components'
import VisorPDF from '../../components/Visor/VisorPDF'
import { Box, Card, Checkbox, Grid, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';



const BoxContainer = styled(Box)(({ theme }) => ({
  height: "auto",
  width: "100%",
  justifyContent: "space-between",
  marginTop: 5,
  marginBottom: 1,
  borderBottom: "1px solid #D9D9D9",
  display: "flex",
}));

const BoxTitulo = styled(Box)(({ theme }) => ({
  wordWrap: "break-word",
  width: "40%",
  [theme.breakpoints.down("sm")]: {
    width: "40%",
  },
}));

const BoxTexto = styled(Box)(({ theme }) => ({
  wordWrap: "break-word",
  textAlign: "right",
  width: "60%",
  [theme.breakpoints.down("sm")]: {
    width: "60%",
  },
}));

const data = [
  {
    invoice: "uno",
    product: "Tipo de documento",
    plantilla: "product",
    action: "product",
  },
  {
    invoice: "Dos",
    product: "Tipo de documento",
    plantilla: "product",
    action: "product",
  },
  {
    invoice: "tres",
    product: "Tipo de documento",
    plantilla: "product",
    action: "product",
  },
];

export default function UserGroupMasiveSign() {
  const [selected, setSelected] = React.useState([]);
  const { t } = useTranslation();
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  return (
    <GenericContainer>
      <Box style={{ marginBottom: '3.5em' }}>
        <Typography
          variant="h6"
          gutterBottom
          style={{ margin: '.6em' }}
        >
          {t("select_candidates_apply")}
        </Typography>
        <Grid container>
          {data?.map((row, index) => {
            const isItemSelected = isSelected(row);
            const labelId = `enhanced-table-checkbox-${index}`;
            return (
              <CardDocumentKit
                row={row}
                isItemSelected={isItemSelected}
                labelId={labelId}
                handleClick={handleClick}
              />
            )
          })}
        </Grid>
      </Box>
      <Buttons
        teConfirmButtonTextxt={t("legal_sign")}
        onClickConfirm={""}
      />
    </GenericContainer>
  )
};

const CardDocumentKit = (props) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <Grid item lg={5} xs={12} >
      <Card style={{ marginTop: '.7em', marginLeft: '.8em' }}>
        <Box
          onClick={() => setOpen(!open)}
          // onClick={(event) => props.row.Status === "Firma de documentos por Legal Rep" ? props.handleClick(event, props.row) : null}
          disabled={true}
          aria-checked={props.isItemSelected}
          style={{
            p: 1,
            m: 0.8,
            border: 1.5,
            borderColor: "#ECECEC",
          }}
        >
          <Box style={{ background: '#0060A2', borderTopLeftRadius: '15px', borderTopRightRadius: '15px', color: 'white', display: "flex", alignItems: "center" }}>
            {props.row.Status === "Firma de documentos por Legal Rep" ? (
              <Checkbox
                style={{ color: '#FFFFFF' }}
                checked={props.isItemSelected}
                inputProps={{ 'aria-labelledby': props.labelId }}
              />
            ) : (
              <Checkbox
                style={{ color: '#' }}
                checked={null}
              // inputProps={{ 'aria-labelledby': labelId }}
              />
            )}

            <Typography variant="h6" >
              Folio: {props.row.Code}
            </Typography>
          </Box>
          <Statements title={"Nombre:"} text={props.row.FullName} />
          <Statements title={"Puesto:"} text={props.row.Puesto} />
          <Statements title={"Estatus:"} text={props.row.Status} />
          {props.row.Procesar === true ? (
            props.row?.map((item) => (
              <BoxContainer>
                {console.log('itemitem', item)}
                <BoxTitulo>
                  <Typography variant="subtitle1" style={{ fontWeight: 500, padding: '.7em', margin: '0px' }}>
                    <b>
                      {item.Name}
                    </b>
                  </Typography>
                </BoxTitulo>
                <BoxTexto>
                  {/*  <DocumentViewModal
                    Name={item.Name}
                    data={item}
                  /> */}
                </BoxTexto>
              </BoxContainer>
            ))
          ) : null}
        </Box>
      </Card>
      <CustomAlertDialog
        open={open}
        title={t("hiring_kit")}
        textAcepted={t("general_accept")}
        closeAction={() => setOpen(!open)}
        Body={
          <Box>
            HOLA MUNDO VISOR PDF
            <VisorPDF pdfUrl={''} pdfName={""} height={"70vh"} />
          </Box>
        }
      />

    </Grid>
  )
}

const Statements = (props) => {
  return (
    <BoxContainer>
      <BoxTitulo>
        <Typography variant="subtitle1" style={{ fontWeight: 500, padding: '.7em', margin: '0px' }}>
          <b>
            {props.title}
          </b>
        </Typography>
      </BoxTitulo>
      <BoxTexto>
        <Typography variant="subtitle1" textAlign={"right"} style={{ padding: '.7em', margin: '0px' }}>
          {props.text}
        </Typography>
      </BoxTexto>
    </BoxContainer>
  );
};
